import React, { useState } from 'react'
import { Dropdown } from '../../helpers/components/Dropdown'
import PaymentDetails from '../../components/account/accountModal/PaymentDetails'
import { Modal } from 'antd'
import UpdatePlan from '../../components/account/accountModal/UpdatePlan'
import { useNavigate } from 'react-router-dom'

interface Props {
  accountActionDropdownMenuRefs: React.MutableRefObject<any[]>
  user: any
  index: number
}

const AccountActionMenu: React.FC<Props> = ({ accountActionDropdownMenuRefs, user, index }) => {
  const [accountActionMenuDroppedDown, setAccountActionMenuDroppedDown] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isUpdatePackageModalOpen, setIsUpdatePackageModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const updateClientOnboardingInfo = (user: any) => {
    setAccountActionMenuDroppedDown(!accountActionMenuDroppedDown)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const packageModalOpen = () => {
    setIsUpdatePackageModalOpen(true)
  }

  const updatePackageHandleOk = () => {
    setIsUpdatePackageModalOpen(false)
  }

  const updatePackageCancel = () => {
    setIsUpdatePackageModalOpen(false)
  }

  const toNavigate = () => {
    navigate(`/account/billing-history/${user.bgAccountId}`)
  }

  const menuItems = [
    {
      label: 'Update Package',
      icon: 'bi-pencil-square',
      color: 'link-primary',
      onClick: packageModalOpen
    },
    {
      label: 'Payment Details',
      icon: 'bi-credit-card',
      color: 'link-info',
      onClick: showModal
    },
    {
      label: 'Billing History',
      icon: 'bi-receipt',
      color: 'link-success',
      onClick: toNavigate
    }
  ]

  return (
    <>
      <button
        className={`btn btn-sm btn-icon btn-active-light-primary`}
        onClick={() => updateClientOnboardingInfo(user)}
      >
        <i className='bi bi-three-dots-vertical fs-2'></i>
      </button>
      <Dropdown
        menuRef={accountActionDropdownMenuRefs.current[index]}
        droppedDown={accountActionMenuDroppedDown}
        setDroppedDown={setAccountActionMenuDroppedDown}
      >
        <div className='p-5 py-3'>
          {menuItems.map((item, idx) => (
            <p
              key={item.icon}
              className={`${item.color} hoverable`}
              role='button'
              onClick={item.onClick}
            >
              <i className={`bi ${item.icon} ${item.color}`}></i>
              <span className='px-2'>{item.label}</span>
            </p>
          ))}
        </div>
      </Dropdown>

      <Modal
        title='Payment Details'
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
      >
        <PaymentDetails isPaymentDetails={user} />
      </Modal>

      {/* Modals */}
      <Modal
        title='Update Package'
        open={isUpdatePackageModalOpen}
        onOk={updatePackageHandleOk}
        onCancel={updatePackageCancel}
        footer={false}
        destroyOnClose
      >
        <UpdatePlan closeModal={updatePackageCancel} isPaymentDetails={user} />
      </Modal>
    </>
  )
}

export default AccountActionMenu
